import {
  ArrowDownOutlined,
  ClockCircleOutlined,
  FileOutlined,
  UsergroupDeleteOutlined,
} from '@ant-design/icons';
import { selectXRayAnalytics } from '@mm/state/selectors/botAnalyticsSelector';
import React from 'react';
import { useSelector } from 'react-redux';
import { StatBox } from '../../EmailAnalytics/EmailSummaryStats';
import { ReactComponent as ClickedIcon } from 'assets/click.svg';
import styles from './XRayAnalyticsAvgSummary.module.css';
import moment from 'moment';
import { getMinutesAndSeconds } from '../../../Contacts/MyLeadsFiltersPanel/helpers';

export const XRayAnalyticsAvgSummary = () => {
  const emailAnalytics = useSelector(selectXRayAnalytics);
  const data = emailAnalytics.avg_lead_scores?.avgLeadScores;

  return (
    <div className={styles.container}>
      <div className={styles.header}>Website Traffic </div>
      <div className={styles.statsContainer}>
        <StatBox
          className={styles.box}
          label="Avg. page views"
          icon={<FileOutlined className={styles.icon} />}
          stat={data?.webPageViews?.toFixed(2) || '0'}
        />
        <StatBox
          className={styles.box}
          label="Avg. time on site"
          icon={<ClockCircleOutlined className={styles.icon} />}
          stat={getMinutesAndSeconds(data?.timeOnSite || 0, true) || ''}
        />
        <StatBox
          className={styles.box}
          label="Avg. clicks during session"
          icon={<ClickedIcon className={styles.icon} />}
          stat={data?.numOfClicks?.toFixed(2) || '0'}
        />
        <StatBox
          className={styles.box}
          label="Avg. scroll depth"
          icon={<ArrowDownOutlined className={styles.icon} />}
          stat={data?.scrollDepth?.toFixed(2) || '0'}
          note="Inches"
        />
      </div>
    </div>
  );
};
